import styled from 'styled-components';
import { AiOutlineSelect } from 'react-icons/ai';

export const Wrap = styled.div`
  height: 85%;
  min-width: 65%;

  background-color: white;
  margin: 0 25px;

  padding: 0 25px 25px 25px;
  border-radius: 4px;
  box-shadow: 0 0 1px #eaeaea inset;
`;

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;

  button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    color: #8e8e8e;
    font-weigth: 300;

    display: flex;
    align-items: center;
  }
`;

export const Icon = styled(AiOutlineSelect)`
  margin-right: 7px;
  transform: scaleX(-1);
`;

export const Content = styled.div``;
